import React, { PureComponent } from "react";
import Dashboard from "./Containers/InstanceDashboardContainer";

class InstanceDashboard extends PureComponent {
  render() {
    return (
      <div>
        <Dashboard
          instance_id={this.props.match.params.id}
          searchParams={this.props.location.search}
        />
      </div>
    );
  }
}

export default InstanceDashboard;
